import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSection31,
  fetchSection311,
  fetchSection32,
  fetchSection4,
  fetchSection5,
} from "./Gstr3BSummaryThunk";

const initialState = {
  loading: false,
  error: null,

  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },

  // 🔥 separate storage per section
  section3_1: [],
  section3_1_1: [],
  section3_2: [],
  section4: [],
  section5: [],
};

const slice = createSlice({
  name: "gstr3b",
  initialState,

  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    resetData: (state) => {
      state.section3_1 = [];
      state.section3_1_1 = [];
      state.section3_2 = [];
      state.section4 = [];
      state.section5 = [];
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // =====================
      // Section 3.1
      // =====================
      .addCase(fetchSection31.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSection31.fulfilled, (state, action) => {
        state.loading = false;
        state.section3_1 = action.payload || [];
      })
      .addCase(fetchSection31.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =====================
      // Section 3.1.1
      // =====================
      .addCase(fetchSection311.fulfilled, (state, action) => {
        state.section3_1_1 = action.payload || [];
      })

      // =====================
      // Section 3.2
      // =====================
      .addCase(fetchSection32.fulfilled, (state, action) => {
        state.section3_2 = action.payload || [];
      })

      // =====================
      // Section 4
      // =====================
      .addCase(fetchSection4.fulfilled, (state, action) => {
        state.section4 = action.payload || [];
      })

      // =====================
      // Section 5
      // =====================
      .addCase(fetchSection5.fulfilled, (state, action) => {
        state.section5 = action.payload || [];
      });
  },
});

export const { setFilters, resetData } = slice.actions;
export default slice.reducer;